module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('markup-wrapper', {
    staticClass: "__page-error"
  }, [_c('div', {
    staticClass: "wrapper-text"
  }, [_c('span', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.code))]), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.tooltip))]), _c('span', {
    staticClass: "text"
  }, [_vm._t("default")], 2)]), _c('div', {
    staticClass: "wrapper-image"
  }, [_c('img', {
    attrs: {
      "src": require("./angry.png"),
      "alt": _vm.info
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a63143","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/error/Error.vue
// module id = e5f1203d3e27882ef2aa
// module chunks = 0